
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/homes",
      function () {
        return require("private-next-pages/shop/homes/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/homes"])
      });
    }
  